import { render, staticRenderFns } from "./JoinGame.vue?vue&type=template&id=3bfac09c&"
import script from "./JoinGame.vue?vue&type=script&lang=ts&"
export * from "./JoinGame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports